var _rect, _rect2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16486_294565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V16H23V1H1Z",
    fill: "#012169"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16486_294565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1V16H23V1H1Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1L23 16L1 1ZM23 1L1 16L23 1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6786 2.28633L14.5651 8.5001L23.6786 14.7139L22.3203 17.2863L11.9995 10.2494L1.6786 17.2863L0.320312 14.7139L9.43383 8.5001L0.320312 2.28633L1.6786 -0.286133L11.9995 6.75081L22.3203 -0.286133L23.6786 2.28633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.66619L2.71041 16H1L12 8.5V9.66619ZM13.7104 8.5L23 14.8338V16L12 8.5H13.7104ZM12 8.5V7.33379L21.2896 1H23L12 8.5ZM12 8.5H10.2896L1 2.16619V1L12 8.5Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 6.5H10.2425V0.5H13.7625V6.5H23.4425V10.5H13.7625V16.5H10.2425V10.5H0.5625V6.5Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1972 0V6H23.8772V11H14.1972V17H9.79719V11H0.117188V6H9.79719V0H14.1972ZM10.6772 7H0.997188V10H10.6772V16H13.3172V10H22.9972V7H13.3172V1H10.6772V7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.6418cdd65adabfceb40b6762d8e245bb.svg";
export { ForwardRef as ReactComponent };